var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.displayTermsAndPolicy)?_c('terms-and-policy'):_vm._e(),_vm._v(" "),(_vm.displaySignUp)?_c('sign-up'):_vm._e(),_vm._v(" "),(_vm.isRegistrated)?_c('celebration'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }